import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Link from 'next/link';
import { useSelector } from 'store';

var RetailListService = function RetailListService() {
  var retails = useSelector(function (state) {
    return state.space.retails;
  });
  return /*#__PURE__*/_jsx("div", {
    className: "cnts-wrap",
    children: /*#__PURE__*/_jsx("div", {
      className: "retail-list",
      children: /*#__PURE__*/_jsx("div", {
        className: "list-wrap",
        children: /*#__PURE__*/_jsx("ul", {
          children: retails.results && retails.results.map(function (retail) {
            return /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                href: "/retail/".concat(retail.id),
                children: /*#__PURE__*/_jsxs("a", {
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "info",
                    children: [/*#__PURE__*/_jsx("strong", {
                      children: retail.name
                    }), /*#__PURE__*/_jsx("p", {
                      children: retail.summary
                    })]
                  }), /*#__PURE__*/_jsx("span", {
                    className: "thumb",
                    style: {
                      backgroundImage: "url('".concat(retail.representation_image, "')")
                    }
                  })]
                })
              })
            }, retail.id);
          })
        })
      })
    })
  });
};

export default RetailListService;